import { ServerCog } from "lucide-react";
import { SettingsForm, SYSTEM_GROUPS } from "./Business";
import BrandSection from "../../components/admin/BrandSection";

/**
 * System Settings (v4.4.3) — platform-level configuration: brand identity,
 * outgoing email transport, the security & health audit and email templates.
 * Reuses the shared settings form so saving still hits PUT /admin/settings.
 */
export default function SystemSettings() {
  return (
    <div className="max-w-6xl px-6 lg:px-10 pt-6 lg:pt-10 pb-12" data-testid="system-settings-page">
      <div className="mb-8">
        <p className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 dark:text-neutral-400">
          Platform
        </p>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight mt-2 flex items-center gap-3">
          <ServerCog size={28} /> System settings
        </h1>
        <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-2 max-w-2xl">
          Brand identity, outgoing email delivery, notification templates and the
          security &amp; system health audit.
        </p>
      </div>

      <div className="space-y-6 max-w-3xl">
        <BrandSection />
        <SettingsForm groups={SYSTEM_GROUPS} testId="system-settings-form" embedded />
      </div>
    </div>
  );
}
